import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { Context, Transitions } from "../../../types"
import { getServiceErrorMessage } from "../../../helpers"

export const downloadResourcesTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    id: "downloadResources",
    src: "getLessonDetails",
    onDone: {
      target: "#StudyPlan.teacher_view.idle",
      actions: assign((_ctx, evt) => ({
        selectedForDownloadItem: evt.data,
        selectedLessonId: null,
        selectedSectionId: null
      }))
    },
    onError: {
      target: "#StudyPlan.teacher_view.idle",
      actions: assign<Context, DoneInvokeEvent<any>>({
        snackbar: (_ctx, evt) => ({
          message: getServiceErrorMessage("getLessonDetails", {
            messageData: ["download resources"]
          }),
          withUndo: false,
          error: true
        }),
        selectedLessonId: null,
        selectedSectionId: null
      })
    }
  }
}
